import dict from './stores/dictStore';

const each = (object, callback) => {
    if (!isObject(object) && typeof object.length !== 'undefined') {
        for (var i = 0, length = object.length; i < length; i++) {
            var value = object[i];
            if (callback.call(value, i, value) === false) break;
        }
    } else {
        for (var name in object) {
            if (!Object.prototype.hasOwnProperty.call(object, name)) continue;
            if (callback.call(object[name], name, object[name]) === false)
                break;
        }
    }

    return object;
}

export const slugify = (string) => {
    const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
    const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
    const p = new RegExp(a.split('').join('|'), 'g');

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters in a with b
        .replace(/&/g, '-and-') // Replace & with ‘and’
        .replace(/[^\w-]+/g, '') // Remove all non-word characters such as spaces or tabs
        .replace(/--+/g, '-') // Replace multiple — with single -
        .replace(/^-+/, '') // Trim — from start of text
        .replace(/-+$/, ''); // Trim — from end of text
};

export const urlSlug = (id, title = '') => {
    if (!title) title = '';
    return `${id}${title && `_${slugify(title)}`}`;
};

export const replaceAll = (search, replace, str) => {
    while (str.search(search) !== -1) {
        str = str.replace(search, replace);
    }
    return str;
}

export const declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export const setStyle = (elem, name, value) => {
    elem = document.getElementById(elem);
    if (!elem) return;
    if (typeof name == 'object') {
        return each(name, function (k, v) {
            setStyle(elem, k, v);
        });
    }
    if (name == 'opacity') {
        if (browser.msie === true) {
            if ((value + '').length) {
                if (value !== 1) {
                    elem.style.filter = 'alpha(opacity=' + value * 100 + ')';
                } else {
                    elem.style.filter = '';
                }
            } else {
                elem.style.cssText = elem.style.cssText.replace(/filter\s*:[^;]*/gi, '');
            }
            elem.style.zoom = 1;
        }
        elem.style.opacity = value;
    } else {
        try {
            var isN = typeof (value) == 'number';
            if (isN && (/height|width/i).test(name)) {
                value = Math.abs(value);
            }
            elem.style[name] = isN && !(/z-?index|font-?weight|opacity|zoom|line-?height/i).test(name) ? value + 'px' : value;
        } catch (e) {
            console.log('setStyle::error - ', [name, value]);
        }
    }
}

export const browser = () => {
    let _ua;
    if (!window._ua) {
        _ua = navigator.userAgent.toLowerCase();
    }

    return {
        version: (_ua.match(/.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([\d.]+)/) || [0, '0'])[1],
        opera: (/opera/i.test(_ua) || /opr/i.test(_ua)),
        msie: (/msie/i.test(_ua) && !/opera/i.test(_ua) || /trident\//i.test(_ua)),
        msie6: (/msie 6/i.test(_ua) && !/opera/i.test(_ua)),
        msie7: (/msie 7/i.test(_ua) && !/opera/i.test(_ua)),
        msie8: (/msie 8/i.test(_ua) && !/opera/i.test(_ua)),
        msie9: (/msie 9/i.test(_ua) && !/opera/i.test(_ua)),
        mozilla: /firefox/i.test(_ua),
        chrome: /chrome/i.test(_ua),
        safari: (!(/chrome/i.test(_ua)) && /webkit|safari|khtml/i.test(_ua)),
        iphone: /iphone/i.test(_ua),
        ipod: /ipod/i.test(_ua),
        iphone4: /iphone.*OS 4/i.test(_ua),
        ipod4: /ipod.*OS 4/i.test(_ua),
        ipad: /ipad/i.test(_ua),
        android: /android/i.test(_ua),
        bada: /bada/i.test(_ua),
        mobile: /iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(_ua),
        msie_mobile: /iemobile/i.test(_ua),
        safari_mobile: /iphone|ipod|ipad/i.test(_ua),
        opera_mobile: /opera mini|opera mobi/i.test(_ua),
        opera_mini: /opera mini/i.test(_ua),
        mac: /mac/i.test(_ua),
        windows: /windows/i.test(_ua),
        search_bot: /(yandex|google|stackrambler|aport|slurp|msnbot|bingbot|twitterbot|ia_archiver|facebookexternalhit)/i.test(_ua),
        da: /(da)/i.test(_ua)
    }
};

export const getTime = () => { return Math.round((new Date).getTime() / 1000); }
export const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const isObject = (obj) => typeof obj === "object" && obj !== null;

export const numberFormat = (number, decimals, dec_point, thousands_sep) => {
    // * example 1: number_format(1234.56);
    // * returns 1: '1,235'
    // * example 2: number_format(1234.56, 2, ',', ' ');
    // * returns 2: '1 234,56'
    // * example 3: number_format(1234.5678, 2, '.', '');
    // * returns 3: '1234.57'
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? '' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}


export const sprintf = () => { // Return a formatted string
    var regex = /%%|%(\d+\$)?([\-+#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegEG])/g;
    var a = arguments, i = 0, format = a[i++];

    // pad()
    var pad = function (str, len, chr, leftJustify) {
        var padding = (str.length >= len) ? '' : (new Array(1 + len - str.length >>> 0)).join(chr);
        return leftJustify ? str + padding : padding + str;
    };

    // justify()
    var justify = function (value, prefix, leftJustify, minWidth, zeroPad) {
        var diff = minWidth - value.length;
        if (diff > 0) {
            if (leftJustify || !zeroPad) {
                value = pad(value, minWidth, ' ', leftJustify);
            } else {
                value = value.slice(0, prefix.length) + pad('', diff, '0', true) + value.slice(prefix.length);
            }
        }
        return value;
    };

    // formatBaseX()
    var formatBaseX = function (value, base, prefix, leftJustify, minWidth, precision, zeroPad) {
        // Note: casts negative numbers to positive ones
        var number = value >>> 0;
        prefix = prefix && number && { '2': '0b', '8': '0', '16': '0x' }[base] || '';
        value = prefix + pad(number.toString(base), precision || 0, '0', false);
        return justify(value, prefix, leftJustify, minWidth, zeroPad);
    };

    // formatString()
    var formatString = function (value, leftJustify, minWidth, precision, zeroPad) {
        if (precision !== null) {
            value = value.slice(0, precision);
        }
        return justify(value, '', leftJustify, minWidth, zeroPad);
    };

    // finalFormat()
    var doFormat = function (substring, valueIndex, flags, minWidth, _, precision, type) {
        if (substring === '%%') { return '%'; }

        // parse flags
        var leftJustify = false, positivePrefix = '', zeroPad = false, prefixBaseX = false;
        for (var j = 0; flags && j < flags.length; j++) {
            switch (flags.charAt(j)) {
                case ' ': positivePrefix = ' '; break;
                case '+': positivePrefix = '+'; break;
                case '-': leftJustify = true; break;
                case '0': zeroPad = true; break;
                case '#': prefixBaseX = true; break;
            }
        }

        // parameters may be null, undefined, empty-string or real valued
        // we want to ignore null, undefined and empty-string values
        if (!minWidth) {
            minWidth = 0;
        } else if (minWidth === '*') {
            minWidth = +a[i++];
        } else if (minWidth.charAt(0) === '*') {
            minWidth = +a[minWidth.slice(1, -1)];
        } else {
            minWidth = +minWidth;
        }

        // Note: undocumented perl feature:
        if (minWidth < 0) {
            minWidth = -minWidth;
            leftJustify = true;
        }

        if (!isFinite(minWidth)) {
            throw new Error('sprintf: (minimum-)width must be finite');
        }

        if (!precision) {
            precision = 'fFeE'.indexOf(type) > -1 ? 6 : (type === 'd') ? 0 : void (0);
        } else if (precision === '*') {
            precision = +a[i++];
        } else if (precision.charAt(0) === '*') {
            precision = +a[precision.slice(1, -1)];
        } else {
            precision = +precision;
        }

        // grab value using valueIndex if required?
        var value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++],
            number, prefix;

        switch (type) {
            case 's': return formatString(String(value), leftJustify, minWidth, precision, zeroPad);
            case 'c': return formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, zeroPad);
            case 'b': return formatBaseX(value, 2, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
            case 'o': return formatBaseX(value, 8, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
            case 'x': return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
            case 'X': return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad).toUpperCase();
            case 'u': return formatBaseX(value, 10, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
            case 'i':
            case 'd': {
                number = parseInt(+value, 10);
                prefix = (number < 0 ? '-' : positivePrefix);
                value = prefix + pad(String(Math.abs(number)), precision, '0', false);
                return justify(value, prefix, leftJustify, minWidth, zeroPad);
            }
            case 'e':
            case 'E':
            case 'f':
            case 'F':
            case 'g':
            case 'G': {
                number = +value;
                prefix = (number < 0 ? '-' : positivePrefix);
                var method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(type.toLowerCase())];
                var textTransform = ['toString', 'toUpperCase']['eEfFgG'.indexOf(type) % 2];
                value = prefix + Math.abs(number)[method](precision);
                return justify(value, prefix, leftJustify, minWidth, zeroPad)[textTransform]();
            }
            default: return substring;
        }
    };

    return format.replace(regex, doFormat);
}

export const dateTextFormat = (date) => {
    let time = new Date(date),
        day = time.getDate(),
        month = time.getMonth() + 1,
        minutes = time.getMinutes(),
        cur_date = new Date(),
        time_passed = (cur_date.getTime() - time.getTime()) / 1000,
        date_str = date,
        date_arr2 = [],
        date_arr = [];

    minutes = minutes < 10 ? '0' + minutes : minutes;

    if (isNaN(time.getTime())) { }
    else if (time_passed < 60) { // 1 min
        date_str = Math.floor(time_passed) + '|S_SEC|AGO';
    }
    else if (time_passed < 3600) { // 1 hour
        date_str = Math.ceil(time_passed / 60) + '|S_MIN|AGO';
    }
    else if (cur_date.getDate() - 1 === time.getDate() && cur_date.getMonth() === time.getMonth() && cur_date.getFullYear() === time.getFullYear()) { // yesterday
        date_str = 'S_YESTERDAY|IN|' + time.getHours() + ':' + minutes;
    }
    else if (time_passed < 86400) { // 1 day
        date_str = Math.ceil(time_passed / 3600) + '|S_HOUR|AGO';
    }
    else if (time_passed < 604800) { // 7 days
        date_str = Math.floor(time_passed / 86400) + '|S_DAY|AGO';
    }
    else if (cur_date.getFullYear() === time.getFullYear()) {
        date_str = day + '|S_MONTH' + month + '|IN|' + time.getHours() + ':' + minutes;
    } else {
        date_str = time.getDate() + '|S_MONTH' + month + '|' + time.getFullYear();
    }

    if (date_str.length) {
        date_arr = date_str.split('|');
        for (var i = 0; i < date_arr.length; i++) {
            date_arr2.push(dict.getLang(date_arr[i]));
        }

        return date_arr2.join(' ');
    }
    return date;
};

export const dateTextFormat2 = (date) => {
    let time = new Date(date),
        day = time.getDate(),
        month = time.getMonth() + 1,
        cur_date = new Date(),
        time_passed = (cur_date.getTime() - time.getTime()) / 1000,
        date_str = date,
        date_arr2 = [],
        date_arr = [];

    if (isNaN(time.getTime())) { }
    else if (time_passed < 60) { // 1 min
        date_str = Math.floor(time_passed) + '|S_SEC|AGO';
    }
    else if (time_passed < 3600) { // 1 hour
        date_str = Math.ceil(time_passed / 60) + '|S_MIN|AGO';
    }
    else if (cur_date.getDate() - 1 === time.getDate() && cur_date.getMonth() === time.getMonth() && cur_date.getFullYear() === time.getFullYear()) { // yesterday
        date_str = 'S_YESTERDAY';
    }
    else if (cur_date.getDate() === time.getDate() && cur_date.getMonth() === time.getMonth() && cur_date.getFullYear() === time.getFullYear()) { // yesterday
        date_str = 'S_TODAY';
    }
    else if (cur_date.getFullYear() === time.getFullYear()) {
        date_str = day + '|S_MONTH' + month;
    } else {
        date_str = time.getDate() + '|S_MONTH' + month + '|' + time.getFullYear();
    }

    if (date_str.length) {
        date_arr = date_str.split('|');
        for (var i = 0; i < date_arr.length; i++) {
            date_arr2.push(dict.getLang(date_arr[i]));
        }

        return date_arr2.join(' ');
    }

    return date;
};

export const getIdFromSlug = (slug) => {
    if (!slug) return '';

    const id = slug.split('_')[0];
    return isNumber(id) ? id : slug;
};

export const isNumber = obj => !Number.isNaN(Number(obj));

export const getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return false;
};

// export class dict {
//         this.reg_exp_ru = new RegExp('[[А-Яа-я]+');

//         var d = this;
//         window.dict = this;
//         window.getLang = function(key, replace) {
//             return d.get(key, replace);
//         }
//     };
//     z.fn.dict.prototype = {
//         constructor: z.fn.dict,
//         add : function (data) {
//             for(var i in data) {
//                 this[i] = data[i];
//             }
//         },
//         get : function(key, replace) {
//             var lang = '';
//             if (key === null || typeof key == 'string' && key.length == 0) {
//             }
//             else if (isset(this[key])) {
//                 lang = this[key];
//             }
//             else if (window.dict_data && window.dict_data[key]) {
//                 lang = window.dict_data[key];
//             }
//             else if (this.reg_exp_ru.test(key) === false) {
//                 lang = key.toString().toLowerCase().split('_').join(' ');
//                 if (lang.length) {
//                     lang = lang[0].toUpperCase() + lang.substr(1);
//                 }
//             } else {
//                 lang = key;
//             }

//             if (replace) {
//                 lang = this.replace(lang, replace);
//             }

//             return lang;
//         },
//         replace : function(text, opts) {
//             for(var i in opts) {
//                 text = text.replace('{' + i + '}', opts[i]);
//             }

//             return text;
//         }
//     };


// WEBPACK FOOTER //
// ./src/common.js